import styled from 'styled-components';

export const ScPaymentMethodCardMobile = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  z-index: 1;
  button {
    border-radius: 8px;
    width: 109px;
    height: 32px;
    border: none;
    &.active {
      border: 1px solid #1cd57a;
      background-color: rgba(28, 213, 122, 0.1);
    }
  }
`;
